import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SessionService {
    public apiUrl: string = environment.webApiDefaultRoot;
    // Engagement ID to focus on
    public engagementIdFocus: any;

    // Role of user
    public userRole: string = 'champion';

    public clientName: string = '';
    engagementName: string;
    engagementNumber: string;

    private _engagementName: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _engagementNumber: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    private isFavoriteStudy = new BehaviorSubject<boolean>(false);
    isFavoriteStudy$ = this.isFavoriteStudy.asObservable();

    constructor(public request: HttpClient) {
        this.apiUrl = environment.webApiDefaultRoot;
    }

    setIsStudyFavorite(isfav: boolean): void {
        this.isFavoriteStudy.next(isfav);
    }

    getIsFavoriteStudyValue(): boolean {
        return this.isFavoriteStudy.getValue();
    }

    apiUrlGet = urlRequest => {
        let getOptions = {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            }),
        };
        return this.request.get(this.apiUrl + urlRequest, getOptions);
    };

    apiUrlDelete = (urlRequest, dataToSend) => {
        let deleteOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: dataToSend,
        };
        return this.request.delete(this.apiUrl + urlRequest, deleteOptions);
    };

    apiUrlPost = (urlRequest, dataToSend) => {
        let PostOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })

        };
        return this.request.post(
            this.apiUrl + urlRequest,
            JSON.stringify(dataToSend), PostOptions
        );
    };

    apiUrlPut = (urlRequest, dataToSend) => {
        return this.request.put(this.apiUrl + urlRequest, dataToSend);
    };

    setSession(key: string, value: any) {
        sessionStorage.setItem(key, value.toString());
    }

    setSessionNullable(key: string, value: any) {
        this.setSession(key, value ? value : '');
    }

    getSession(key: string) {
        return sessionStorage.getItem(key);
    }

    getSessionNumber(key: string) {
        return Number(sessionStorage.getItem(key));
    }

    clearSession() {
        sessionStorage.clear();
    }

    removeItem(key: string) {
        sessionStorage.removeItem(key);
    }

    removeNullEmptyValues(patchOutput: any) {
        // Remove properties that are null, empty, or undefined
        for (let propName in patchOutput) {
            if (
                patchOutput[propName] === null ||
                patchOutput[propName] === undefined ||
                patchOutput[propName] === ''
            ) {
                delete patchOutput[propName];
            } else {
                if (patchOutput[propName].length > 0) {
                    patchOutput[propName] = patchOutput[propName].trim();
                }
            }
        }

        // return the new JSON object. This is to be sent to the back-end API
        return patchOutput;
    }

    downloadAsFile(urlRequest: string, dataToSend: any): Observable<Blob> {
        return this.request.post<Blob>(this.apiUrl + urlRequest, dataToSend, {
            responseType: 'blob' as 'json',
        });
    }

    downloadAsFileGet(urlRequest: string): Observable<Blob> {
        return this.request.get<Blob>(this.apiUrl + urlRequest, {
            responseType: 'blob' as 'json',
        });
    }

    setEngagementNameAndNumber(engagementName: string, engagementNumber: string) {
        this.engagementName = engagementName;
        this.engagementNumber = engagementNumber;
        this.setSessionNullable('engagementName', engagementName);
    }

    GetEngagementName() {
        if (this.engagementName?.length > 0) {
            return this.engagementName;
        }
        else {
            const engagementName = this.getSession('engagementName')?.toString();
            this.engagementName = engagementName?.length > 0 ? engagementName : '';
            return this.engagementName;
        }
    }

    GetEngagementNumber() {
        return this.engagementNumber;
    }
    public getEngagementName() {
        return this._engagementName.asObservable();
    }
    public setEngagementName(value: string) {
        this._engagementName.next(value);
    }
    public getEngagementNumber() {
        return this._engagementNumber.asObservable();
    }
    public setEngagementNumber(value: string) {
        this._engagementNumber.next(value);
    }
}
